import {useEffect,useState} from 'react';

const prefix='workview:field-view:';
export type FieldViewState={viewedTech:string;selectedId:string;scheduleDay:string;timesheetDay:string;homeView:'home'|'timesheet'};
export function fieldViewKey(userId:string){return `${prefix}${userId}`;}
export function readFieldView(userId:string|undefined):FieldViewState|null{
  if(!userId)return null;
  try{
    const value=JSON.parse(sessionStorage.getItem(fieldViewKey(userId))??'null');
    if(!value||typeof value!=='object')return null;
    const id=(input:unknown)=>typeof input==='string'&&input.length<=160?input:'';
    const date=typeof value.scheduleDay==='string'&&/^\d{4}-\d{2}-\d{2}$/.test(value.scheduleDay)&&!Number.isNaN(Date.parse(value.scheduleDay))?value.scheduleDay:'';
    return {viewedTech:id(value.viewedTech),selectedId:id(value.selectedId),scheduleDay:date,timesheetDay:typeof value.timesheetDay==='string'?value.timesheetDay:'',homeView:value.homeView==='timesheet'?'timesheet':'home'};
  }catch{return null;}
}
export function writeFieldView(userId:string|undefined,value:FieldViewState){
  if(!userId)return;
  try{sessionStorage.setItem(fieldViewKey(userId),JSON.stringify(value));}catch{/* Navigation still works when browser storage is unavailable. */}
}
export function useFieldPanel(storageKey?:string){
  const [open,setOpen]=useState(()=>{try{return storageKey?sessionStorage.getItem(storageKey)==='true':false;}catch{return false;}});
  useEffect(()=>{if(storageKey){try{sessionStorage.setItem(storageKey,String(open));}catch{/* Optional per-tab view preference. */}}},[open,storageKey]);
  return [open,setOpen] as const;
}
